import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import styled from "styled-components";

const LineButtonContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    background: #06C755;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 40px;

    &:hover {
        filter: brightness(1.1);
        transform: translateY(-1px);
    }
    &:active { transform: translateY(0); }
`;

const LineIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 100%;
    flex-shrink: 0;
    background: rgba(0, 0, 0, 0.08);

    & img {
        width: 22px;
        height: 20px;
    }
`;

const LineButton = styled.button`
    flex: 1;
    height: 100%;
    border: none;
    background: transparent;
    color: white;
    font-size: 0.85rem;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    cursor: pointer;
    text-align: center;
    padding: 0 0.5rem;
`;

const LineLoginButton = ({ text = null, onInit = null, extraState = null }) => {
    const CLIENT_ID = process.env.REACT_APP_LINE_LOGIN_CHANNEL_ID;
    const REDIRECT_URI = encodeURIComponent('https://chat.babbleon.ai/auth/line');

    const initLogin = () => {
        let state = uuidv4();
        if (extraState) state = `${state}?${extraState}`;
        sessionStorage.setItem("line_auth_state", state);
        const LINE_AUTH_URL = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&state=${state}&scope=profile%20openid`;
        window.location.href = LINE_AUTH_URL;
    };

    if (!text) text = "Sign in with LINE";
    if (!onInit) onInit = initLogin;

    return (
        <LineButtonContainer onClick={onInit}>
            <LineIcon>
                <img src="/line-icon.png" alt="LINE" />
            </LineIcon>
            <LineButton type="button">{text}</LineButton>
        </LineButtonContainer>
    );
};

export default LineLoginButton;
